import { Component } from "react";

import { Grid } from "components/Grid/Grid";
import { GridColumn } from "components/Grid/GridColumn";
import { GridNoRecords } from "components/Grid/GridNoRecords";

import type { NetActivity } from "models/netActivity";

import "./Debug.scss";

interface NetActivityGridProps {
  activities: NetActivity[];
}

export class NetActivityGrid extends Component<NetActivityGridProps, {}> {
  constructor(opts: NetActivityGridProps) {
    super(opts);

    this.state = {};
  }

  render() {
    return (
      <div className="network-activities">
        Network Activity:
        <div className="network-activities-grid">
          <Grid style={{ height: "100%" }} data={this.props.activities} rowHeight={40}>
            <GridColumn field="url" title="URL" width="380" />
            <GridColumn field="status" title="Status" width="120" />
            <GridColumn field="startTime" title="Start" width="150" />
            <GridColumn field="endTime" title="End" width="150" />
            <GridColumn field="responseStatus" title="Response Status" width="150" />
            <GridColumn field="errorReason" title="Error Reason" width="400" />

            <GridNoRecords>No Network Activity</GridNoRecords>
          </Grid>
        </div>
      </div>
    );
  }
}
